/* eslint-disable no-param-reassign */

/* eslint-disable no-nested-ternary */

/* eslint-disable react/no-array-index-key */

import Checkbox from '@material-ui/core/Checkbox'
// import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'
// import classNames from 'classnames/bind';
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
/**
 *
 * ListFilters
 *
 */
import React from 'react'

import LoadingIndicator from '../../LoadingIndicator'
import TablePaginationActions from '../../TablePagination'
import TableHead from './TableHead'

// eslint-disable-next-line no-unused-vars
// biome-ignore lint/correctness/noUnusedVariables: TODO
const styles = theme => ({
  loaderStyle: {
    width: '100%',
    padding: '20px',
    height: `${48 * 5}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  TableCell: {
    borderRight: '2px solid #eeeef1',
    padding: '10px 6px !important',
  },
})

/* eslint-disable react/prefer-stateless-function */
class SimpleTableWithCheckBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: this.props.loading || true,
      tData: [],
      selected: [],
    }
  }

  onSelectIndividualClick = key => event => {
    const { tData, selected } = { ...this.state }
    if (event.target.checked) {
      tData[key].checkbox.isChecked = event.target.checked
      selected.push({ key, value: tData[key] })
    } else {
      const index = selected.indexOf({ key })
      tData[key].checkbox.isChecked = event.target.checked
      selected.splice(index, 1)
    }
    this.setState({ selected })
    return selected
  }

  tableRow = () => {
    const { classes } = this.props
    const { tData } = this.state
    return tData.map((item, key) => (
      <TableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={`row${
          // biome-ignore lint/suspicious/noArrayIndexKey: TODO
          key
        }`}
        scope="row"
      >
        <TableCell className={classes.TableCell} padding="checkbox" style={{ width: '2%' }}>
          <Checkbox checked={item.checkbox.isChecked} onClick={this.onSelectIndividualClick(key)} />
        </TableCell>
        {Object.keys(item).map(keys => (
          <TableCell
            className={classes.TableCell}
            style={{ width: '2%' }}
            padding="none"
            key={`col${
              // biome-ignore lint/suspicious/noArrayIndexKey: TODO: pre-existing, address separately
              key
            }${Math.random()
              .toString(36)
              .replace(/[^a-z]+/g, '')
              .substr(0, 10)}`}
          >
            {item[keys].value}
          </TableCell>
        ))}
      </TableRow>
    ))
  }

  onSelectAllClick = event => {
    // eslint-disable-next-line prefer-const
    let { tData, selected } = this.state
    if (event.target.checked) {
      selected.splice(0, selected.length)
      tData = Object.assign([], tData).map(data => {
        data.checkbox.isChecked = event.target.checked
        return data
      })
      // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
      tData.forEach((e, key) => selected.push({ key, value: tData[key] }))
    } else {
      selected.splice(0, selected.length)
      tData = Object.assign([], tData).map(data => {
        data.checkbox.isChecked = event.target.checked
        return data
      })
    }
    this.setState({ tData, selected })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loading) this.setState({ loading: true })
    else {
      const tData = nextProps.tData.map(data => {
        data.checkbox = { isChecked: false }
        return data
      })
      this.setState({ tData, loading: false })
    }
  }

  render() {
    const { tHeadData, classes, totalRecords, pageSize, children, handleChangePage, page } = this.props
    const { tData, selected, loading } = this.state
    return (
      <Table className={classes.root} aria-labelledby="tableTitle">
        <TableHead data={tHeadData} onSelectAllClick={this.onSelectAllClick} tData={tData} selected={selected} />
        <TableBody>
          {loading ? (
            <TableRow className="text-align-center">
              <TableCell colSpan={tHeadData.length}>
                <LoadingIndicator className={classes.loaderStyle} />
              </TableCell>
            </TableRow>
          ) : tData.length ? (
            totalRecords <= 0 ? (
              <div className={classes.loaderStyle}>
                <p>No Data Found</p>
              </div>
            ) : (
              this.tableRow()
            )
          ) : (
            children
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={8}
              count={totalRecords}
              rowsPerPage={pageSize}
              rowsPerPageOptions={[pageSize]}
              page={page}
              onChangePage={handleChangePage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    )
  }
}

SimpleTableWithCheckBox.defaultProps = {}

export default withStyles(styles)(SimpleTableWithCheckBox)
